import { Alert, Badge, Button, ColorInput, Divider, NumberInput, Select, Stack, Text, Textarea } from '@mantine/core';
import { IconPhoto, IconTypography, IconX } from '@tabler/icons-react';
import { FileButton } from '@mantine/core';

export function NativeObjectInspector({ engine, onClose }) {
  const { selected: item, draft, setDraft, busy } = engine;
  if (!item || !draft) return null;
  const change = (name, value) => setDraft(previous => ({ ...previous, [name]: value }));
  return <aside className="object-inspector unified-inspector">
    <div className="inspector-heading">
      <div><strong>{item.type === 'image' ? 'PDF görseli' : 'PDF metni'}</strong>
        <p>Belgenin özgün içeriğini düzenle</p></div>
      <Button size="compact-xs" variant="subtle" color="gray" leftSection={<IconX size={13}/>} onClick={onClose}>Kapat</Button>
    </div>
    <div className="unified-inspector-scroll"><Stack gap="sm" p="md">
      <Badge variant="light" color={item.type === 'image' ? 'cyan' : 'teal'}>{item.type === 'image' ? 'Gömülü görsel' : 'Özgün metin'}</Badge>
      {!item.editable && <Alert color="orange" title="Sınırlı nesne">{item.warning || 'Bu nesne güvenli şekilde ayrılamıyor.'}</Alert>}
      {engine.error && <Alert color="red" title="İşlem yapılamadı" withCloseButton onClose={() => engine.setError('')}>{engine.error}</Alert>}
      {item.type === 'text' && <>
        <Textarea label="Metin içeriği" minRows={2} autosize value={draft.text || ''} onChange={event => change('text', event.currentTarget.value)} />
        <Select label="Font" value={draft.font_family || 'original'} allowDeselect={false}
          data={[{ value: 'original', label: 'PDF içindeki font (uygunsa)' }, { value: 'sans', label: 'Sans-serif' },
            { value: 'serif', label: 'Serif' }, { value: 'mono', label: 'Monospace' }]}
          onChange={value => change('font_family', value || 'original')} />
        <NumberInput label="Font boyutu (pt)" min={4} max={150} value={draft.size} onChange={value => change('size', Number(value) || 12)} />
        <ColorInput label="Yazı rengi" value={draft.color} onChange={color => change('color', color)} />
      </>}
      <div className="unified-position-grid">
        <NumberInput label="X konumu" decimalScale={1} value={draft.x} onChange={value => change('x', Number(value) || 0)} />
        <NumberInput label="Y konumu" decimalScale={1} value={draft.y} onChange={value => change('y', Number(value) || 0)} />
      </div>
      {item.type === 'image' && <div className="unified-position-grid">
        <NumberInput label="Genişlik" min={1} value={draft.width} onChange={value => change('width', Number(value) || 1)} />
        <NumberInput label="Yükseklik" min={1} value={draft.height} onChange={value => change('height', Number(value) || 1)} />
      </div>}
      <Divider />
      {item.type === 'text'
        ? <Button leftSection={<IconTypography size={17}/>} disabled={!item.editable || busy} loading={busy} onClick={engine.editText}>Metni uygula</Button>
        : <>
            <FileButton onChange={engine.replaceImage} accept="image/png,image/jpeg">
              {props => <Button {...props} leftSection={<IconPhoto size={17}/>} disabled={!item.editable || busy} loading={busy}>Görseli değiştir</Button>}
            </FileButton>
            <Button variant="light" disabled={!item.editable || busy} loading={busy} onClick={engine.moveImage}>Konumu / boyutu uygula</Button>
          </>}
      <Alert color="blue" variant="light" title="Tek çalışma alanı">
        Değişiklik uygulandığında PDF yeniden açılır. Aynı ekran üzerinden sayfa işlemlerine ve metin/görsel eklemeye devam edebilirsiniz.
      </Alert>
      <Text size="xs" c="dimmed">Karmaşık PDF içerikleri, paylaşılan resimler ve çakışan gerçek metinlerde motor belgeyi korumak için işlemi reddedebilir.</Text>
    </Stack></div>
  </aside>;
}
